import {SOPostMessage} from '../../core/message/so-post-message';
import {MessageCore} from './message.core';
import {SOGetMessage} from '../../core/message/so-get-message';
import {FormField, SelectionOption} from 'lionheartland';
import {postMessageFormFieldOptions} from './post-message-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {TopicCore} from '../topic/topic.core';
import {SOGetTopic} from '../../core/topic/so-get-topic';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostMessage extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postMessageFormFieldOptions);

  RequestClass = SOPostMessage

  constructor(
    public entityCore: MessageCore
  ) {
    super();
    if (postMessageFormFieldOptions.topic) {
      postMessageFormFieldOptions.topic.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier(
        'topic',
        SOGetTopic,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}